module.exports = __webpack_public_path__ + "img/explainer-5.810d12ed.jpg";